/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, May 2020
 */

import React from 'react';
import { Question, FlowBlockQuestion, Choice } from '@staffino/model';
import StarsQuestionBlock from './stars-question-block';
import NumbersQuestionBlock from './numbers-question-block';
import EmoticonsQuestionBlock from './emoticons-question-block';
import BinaryQuestionBlock from './binary-question-block';
import YesNoQuestionBlock from './yes-no-question-block';
import BoxesQuestionBlock from './boxes-question-block';
import SliderQuestionBlock from './slider-question-block';
import RadioButtonsQuestionBlock from './radio-buttons-question-block';

type Props = {
  question: Question;
  block: FlowBlockQuestion;
  choices: Choice[];
  onSelect?: any;
};

function calculateSkin(blockSkin: any, questionSkin: Question['skin']) {
  return typeof blockSkin === 'string'
    ? blockSkin
    : (blockSkin?.type ?? questionSkin);
}

export default function ScaleQuestionBlock({
  block,
  question,
  choices,
  onSelect,
}: Props) {
  const skin = calculateSkin((block as any).skin, question.skin);

  if (['Stars', 'stars', 'StarsSingle', 'stars_single'].includes(skin)) {
    return (
      <StarsQuestionBlock
        question={question}
        block={block}
        onSelect={onSelect}
      />
    );
  }

  if (['Slider', 'slider'].includes(skin)) {
    return <SliderQuestionBlock question={question} block={block} />;
  }

  if (
    ['Numbers', 'NumbersGradient', 'numbers', 'numbers_gradient'].includes(skin)
  ) {
    return <NumbersQuestionBlock question={question} block={block} />;
  }

  if (['Emoticons', 'emoticons'].includes(skin)) {
    return (
      <EmoticonsQuestionBlock
        question={question}
        block={block}
        onSelect={onSelect}
      />
    );
  }

  if (['RadioButtons', 'radio_buttons'].includes(skin)) {
    return <RadioButtonsQuestionBlock question={question} block={block} />;
  }

  if (['Boxes', 'BoxesGradient', 'boxes', 'boxes_gradient'].includes(skin)) {
    return (
      <BoxesQuestionBlock question={question} block={block} choices={choices} />
    );
  }

  if (skin === 'Binary') {
    return <BinaryQuestionBlock question={question} block={block} />;
  }

  if (skin === 'YesNo') {
    return <YesNoQuestionBlock question={question} block={block} />;
  }

  return null;
}
